import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { GAuthProvider, useGAuth } from "./GAuth";
import GLayout from "./components/GLayout";
import Accesso from "./pages/Accesso";
import Attivazione from "./pages/Attivazione";
import Invito from "./pages/Invito";
import RecuperoPassword from "./pages/RecuperoPassword";
import Dashboard from "./pages/Dashboard";
import Utenti from "./pages/Utenti";
import Permessi from "./pages/Permessi";
import Registro from "./pages/Registro";
import Profilo from "./pages/Profilo";
import Sistema from "./pages/Sistema";
import Contatti from "./pages/Contatti";
import ContattoDetail from "./pages/ContattoDetail";
import ImmobiliG from "./pages/ImmobiliG";
import ImmobileEditor from "./pages/ImmobileEditor";
import { RichiestaEditor } from "./pages/Richieste";
import Proprietari from "./pages/Proprietari";
import ProprietarioScheda from "./pages/ProprietarioScheda";
import Acquirenti from "./pages/Acquirenti";
import Annunci from "./pages/Annunci";
import FontiDati from "./pages/FontiDati";
import Valutazioni from "./pages/Valutazioni";
import ValutazioneScheda from "./pages/ValutazioneScheda";
import Incarichi from "./pages/Incarichi";
import Agenda from "./pages/Agenda";
import Attivita from "./pages/Attivita";
import Trattative from "./pages/Trattative";
import Provvigioni from "./pages/Provvigioni";
import Report from "./pages/Report";
import Locazioni from "./pages/Locazioni";
import Importazioni from "./pages/Importazioni";
import Avvisi from "./pages/Avvisi";
import AssistenteAI from "./pages/AssistenteAI";
import { DocumentiPage } from "./components/Documenti";

function Guard({ res, titolare, children }) {
  const { can, user } = useGAuth();
  const ok = titolare ? user?.ruolo === "titolare" : can(res);
  if (!ok) return <div className="rounded-2xl border border-border-subtle bg-white p-8 text-sm" data-testid="g-forbidden">Non hai i permessi per questa sezione.</div>;
  return children;
}

export default function GestionaleApp() {
  return (
    <GAuthProvider>
      <div className="font-sans">
        <Routes>
          <Route path="accesso" element={<Accesso />} />
          <Route path="attivazione" element={<Attivazione />} />
          <Route path="invito" element={<Invito />} />
          <Route path="recupero-password" element={<RecuperoPassword />} />
          <Route path="reimposta-password" element={<RecuperoPassword />} />
          <Route element={<GLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="contatti" element={<Guard res="contatti"><Contatti /></Guard>} />
            <Route path="contatti/:id" element={<Guard res="contatti"><ContattoDetail /></Guard>} />
            <Route path="immobili" element={<Guard res="immobili"><ImmobiliG /></Guard>} />
            <Route path="immobili/:id" element={<Guard res="immobili"><ImmobileEditor /></Guard>} />
            <Route path="annunci" element={<Guard res="annunci"><Annunci /></Guard>} />
            <Route path="fonti-dati" element={<Guard res="annunci"><FontiDati /></Guard>} />
            <Route path="valutazioni" element={<Guard res="valutazioni"><Valutazioni /></Guard>} />
            <Route path="valutazioni/:id" element={<Guard res="valutazioni"><ValutazioneScheda /></Guard>} />
            <Route path="acquirenti" element={<Guard res="richieste"><Acquirenti /></Guard>} />
            <Route path="richieste" element={<Navigate to="/gestionale/acquirenti" replace />} />
            <Route path="richieste/:id" element={<Guard res="richieste"><RichiestaEditor /></Guard>} />
            <Route path="proprietari" element={<Guard res="acquisizioni"><Proprietari /></Guard>} />
            <Route path="proprietari/:id" element={<Guard res="acquisizioni"><ProprietarioScheda /></Guard>} />
            <Route path="acquisizioni" element={<Navigate to="/gestionale/proprietari" replace />} />
            <Route path="incarichi" element={<Guard res="incarichi"><Incarichi /></Guard>} />
            <Route path="agenda" element={<Guard res="agenda"><Agenda /></Guard>} />
            <Route path="attivita" element={<Guard res="attivita"><Attivita /></Guard>} />
            <Route path="documenti" element={<Guard res="documenti"><DocumentiPage /></Guard>} />
            <Route path="trattative" element={<Guard res="trattative"><Trattative /></Guard>} />
            <Route path="provvigioni" element={<Guard res="provvigioni"><Provvigioni /></Guard>} />
            <Route path="report" element={<Guard res="report"><Report /></Guard>} />
            <Route path="locazioni" element={<Guard res="locazioni"><Locazioni /></Guard>} />
            <Route path="importazioni" element={<Guard res="importazioni"><Importazioni /></Guard>} />
            <Route path="avvisi" element={<Avvisi />} />
            <Route path="assistente-ai" element={<AssistenteAI />} />
            <Route path="utenti" element={<Guard res="utenti"><Utenti /></Guard>} />
            <Route path="permessi" element={<Guard res="impostazioni"><Permessi /></Guard>} />
            <Route path="registro" element={<Guard res="registro"><Registro /></Guard>} />
            <Route path="sistema" element={<Guard titolare><Sistema /></Guard>} />
            <Route path="profilo" element={<Profilo />} />
            <Route path="*" element={<Navigate to="/gestionale" replace />} />
          </Route>
        </Routes>
      </div>
      <Toaster position="top-center" richColors />
    </GAuthProvider>
  );
}
